import React, { useState } from "react";
import { faEllipsisV } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Draggable } from "react-beautiful-dnd";
import { DataType } from "../../../utils";
import { Card } from "react-bootstrap";
import EditSourceField from "./EditSourceField";
import { Link } from "react-router-dom";
import { useRouterParams } from "../../../abstracts";
import { AddToolTip } from "../../../components";

function ActualSourceFieldComponent({
  handleOnDragEnd,
  fieldArrayName,
  values,
  setFieldValue,
  item,
  index,
  mapped,
  characters,
  setCharacters,
  isOutput,
  clickToSelect,
}) {
  const [isOpen, setisOpen] = useState(false);
  const { mapType } = useRouterParams();

  return (
    <>
      <Draggable
        key={item.id ?? item.fieldName}
        draggableId={item.id ?? item.fieldName}
        index={index}
      >
        {(provided, snapshot) => (
          <li
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
            {item.isFilter != "yes" && (
              <Card className={item.mapped ? "cardCssMapped" : "cardCss"}>
                {!clickToSelect && (
                  <div className="ellipsis">
                    <FontAwesomeIcon
                      icon={faEllipsisV}
                      size="2x"
                      color="#828282"
                    />
                    <FontAwesomeIcon
                      icon={faEllipsisV}
                      size="2x"
                      color="#828282"
                    />
                  </div>
                )}
                <div className="fieldTitle">
                  <span className="passthroughFieldText">
                    <AddToolTip
                      name={
                        item.fieldName
                          ? item.fieldName[0] == "/"
                            ? item.fieldName.substring(1)
                            : item.fieldName
                          : item.displayName
                      }
                    />
                  </span>

                  {
                    // isOutput ? (
                    //   <FontAwesomeIcon
                    //     icon={faCheckCircle}
                    //     size="xs"
                    //     color="#219653"
                    //   />
                    // ) :
                    item.mapped ? (
                      <i
                        class="fal fa-check"
                        style={{ fontWeight: "bolder", color: "#228b22" }}
                      ></i>
                    ) : null
                  }
                </div>
                <div className="columnTitle">
                  <span className="columnText">{item.order}</span>
                </div>
                <div className="d-flex passthroughValueField">
                  <span className="mr-1 fw-400">Value:</span>
                  <AddToolTip name={item.datum ?? 1000} />
                </div>
                <div className="dataType-var">
                  <span className="dataTypeText">
                    {DataType[item.type ?? item.dataType]}
                    {mapType == 3 ? (
                      <></>
                    ) : (
                      !isOutput && (
                        <Link className="ml-auto text-decoration-none">
                          {" "}
                          <i
                            onClick={() => {
                              setisOpen(true);
                            }}
                            style={{ cursor: "pointer" }}
                            className="primary far fa-edit ml-2 "
                          ></i>
                        </Link>
                      )
                    )}
                  </span>
                </div>
              </Card>
            )}

            <EditSourceField
              fieldHeader={
                item.fieldName
                  ? item.fieldName?.replace("/", "")
                  : item.propertyName
              }
              dataType={item.type ?? item.dataType}
              isOpen={isOpen}
              setisOpen={setisOpen}
              characters={characters}
              setCharacters={setCharacters}
              index={item.order ?? index}
            />
          </li>
        )}
      </Draggable>
    </>
  );
}

export default ActualSourceFieldComponent;
